<template>
  <div id="carStatus">
    <div style="margin:10px 0 20px 0">
      <i-circle
        :percent="(onLine / total) * 100"
        :size="220"
        :trail-width="2"
        trail-color="#144a8f"
        :stroke-width="2"
        stroke-color="#fff"
      >
        <p style="margin-bottom: 14px; margin-top: 10px; color: #fff">
          在线 / 总数
        </p>
        <p
          class="demo-Circle-inner"
          style="font-size: 32px; margin-bottom: 15px; color: #fff"
        >
          {{ onLine }} / {{ total }}
        </p>
        <p style="color: #fff; margin-bottom: 10px">
          离线({{ offline }}) / 未上线({{ unactivated }})
        </p>
        <p style="color: #fff">在线率：{{ zai }}%</p>
      </i-circle>
    </div>

    <Row>
      <Col span="8">
        <p class="carNum">{{ driving }}</p>
        <p class="wite">行驶数量</p>
      </Col>
      <Col span="8">
        <p class="carNum">{{ stay }}</p>
        <p class="wite">停留数量</p>
      </Col>
      <Col span="8">
        <p class="carNum">{{ parking }}</p>
        <p class="wite">停车数量</p>
      </Col>
    </Row>
  </div>
</template>
<script>
import axios from "axios";
var t;
export default {
  data() {
    return {
      total: 0,
      stay: 0,
      onLine: 0,
      driving: 0,
      parking: 0,
      zai: 0,
      offline: 0,
      unactivated: 0,
    };
  },
  methods: {
    getCarStatusCount() {
      axios({
        method: "post",
        url: axios.serverWeb + "/screenData/countCarStatus",
        data: {},
      }).then((res) => {
        var data = res.data.data;
        this.total = data.total;
        this.parking = data.parking;
        this.driving = data.driving;
        this.onLine = data.online;
        this.offline = data.offline;
        this.stay = data.stay;
        this.zai = this.zaixianlv(this.onLine);
        this.unactivated = data.unactivated;
      });
    },
    zaixianlv(t) {
      var x;
      var d = (t / this.total) * 100;
      x = d.toFixed(2);
      return x;
    },
  },
  mounted() {
    this.getCarStatusCount();
    t = setInterval(() => {
      this.getCarStatusCount();
    }, 10000);
  },
  destroyed() {
    clearInterval(t);
  },
};
</script>
<style lang="">
#carStatus {
  width: 100%;
  text-align: center;
}
#carStatus .carNum {
  font-size: 32px;
  margin-bottom: 4px;
  color: #fff;
  line-height: 1;
}
#carStatus .wite {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/big/carStatus.vue